<script setup>


const props = defineProps({
  imageSrc: {
    type: String,
    default: '/assets/images/bnr-1.webp' // Default image source
  },
  imageAlt: {
    type: String,
    default: 'WHealthy Coffee' // Default alt text
  },
  mainText: {
    type: String,
    default: 'Secure Your Supply of Our Delicious, Immune-Boosting, Low-Acid Healthy Coffee 58% OFF Today While Supplies Last' // Default main text
  }
});

defineBuilderComponent({
    friendlyName: 'BG Hero With Text',
    inputs: [
        {
            name: 'imageSrc',
            type: 'file',
            allowedFileTypes: ['jpeg', 'jpg', 'png', 'webp'],
            defaultValue: '/assets/images/bnr-1.webp'
        },
        {
            name: 'imageAlt',
            type: 'string',
            defaultValue: 'WHealthy Coffee'
        },
        {
            name: 'mainText',
            type: 'richText',
            defaultValue: 'Secure Your Supply of Our Delicious, Immune-Boosting, Low-Acid Healthy Coffee 58% OFF Today While Supplies Last'
        }
    ]
})
</script>

<template>
  <section class="overflow-hidden relative mt-7 md:mt-6 lg:mt-0 font-ww-medium" style="height:50vh">
    <nuxt-img style="filter: brightness(0.5)" class="object-cover w-full h-full lock"
              :src="imageSrc"
              width="1920"
              height="993"
              loading="lazy"
              format="webp"
              sizes="xs:330px sm:440px md:600px lg:1024px xl:1600px 2xl:1920px"
              :alt="imageAlt"/>

    <div class="flex absolute inset-0 items-center px-5 py-5 m-auto max-w-screen-2xl md:px-7 lg:px-14 xl:px-20 2xl:px-12">
      <div class="w-full text-center">
        <h2 class="mb-4 text-2xl text-white h1 md:mb-6 sm:text-3xl md:text-5xl xl:text-6xl deep-u-display" v-html="mainText"></h2>
      </div>
    </div>
  </section>
</template>

<style>

.deep-u-display u {
  display: inline-block;
}

</style>